import React from 'react';
import { InputNumber, DatePicker, Button, Icon, message } from 'antd';
import Text from '../../../basicElement/Text';
import moment from 'moment';

const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY-MM';

const genMomentDate = date => date ? moment(date) : null;
const findIndex = (data, date) => (data || []).findIndex(i => i[0] === date);

export default function FteRequirement(props) {
    const { asterisk, isChange, params, data, onChange } = props;
    const { fteList } = data;
    const { canEdit = true, isAsh, planBeginTime, planEndTime, termination } = params;

    const disabledDate = (current, type) => {
        const { startMonth, endMonth } = data;
        const startMonthValue = moment(moment(startMonth).format(monthFormat)).valueOf();
        const endMonthValue = moment(moment(endMonth).format(monthFormat)).valueOf();
        const planBeginTimeValue = moment(moment(planBeginTime).format(monthFormat)).valueOf();
        const planEndTimeValue = moment(moment(planEndTime).format(monthFormat)).valueOf();
        const currentValue = moment(current.format(monthFormat)).valueOf();
        const nowValue = moment(moment().format(monthFormat)).valueOf();
        if (nowValue > planEndTimeValue) {
            return true;
        } else if (nowValue < planBeginTimeValue) {
            return current && (currentValue < planBeginTimeValue || currentValue > planEndTimeValue);
        } else if (nowValue >= planBeginTimeValue && nowValue <= planEndTimeValue) {
            if (endMonthValue && type == 'startTime') {
                return current && (currentValue < nowValue || currentValue > endMonthValue);
            } else if (startMonthValue && type == 'endTime') {
                return current && (currentValue < startMonthValue || currentValue > planEndTimeValue);
            } else {
                return current && (currentValue < nowValue || currentValue > planEndTimeValue);
            }
        }
    };

    const handleFteChange = (value, itemIdx, valIdx) => {
        fteList[itemIdx][valIdx] = value;
        onChange(fteList, 'fteList');
    };

    const remove = (index) => {
        fteList.splice(index, 1)
        onChange(fteList, 'fteList');
    };

    const addFte = () => {
        const { startMonth, endMonth, fte, fteList } = data;
        if (!startMonth) {
            return message.warning('请输入起始时间');
        }

        const list = fteList || [];
        // 存在结束月，往fteList中存入开始月到结束月的fte，格式为[month，fte]
        if (endMonth) {
            const start = moment(startMonth);
            const end = moment(endMonth);
            while (end >= start) {
                const month = start.format(monthFormat);
                const index = findIndex(list, month);
                if (index >= 0) {
                    list[index][1] = fte;
                } else {
                    list.push([month, fte]);
                }
                start.add(1, 'M');
            }
        // 否则，只插入/替换一项
        } else {
            const index = findIndex(list, startMonth);
            if (index >= 0) {
                list[index][1] = fte;
            } else {
                list.push([startMonth, fte]);
            }
        }
        list.sort((a, b) => moment(a[0]) - moment(b[0]));
        
        onChange(list, 'fteList');
    };

    const now = moment(moment().format(monthFormat));
    const terminationDate = termination ? moment(termination) : null;
    const getFteContent = () => {
        const result = (fteList || []).map((item, index) => {
            let disabled = false;
            let deletable = true;
            let month;

            if (isChange) {
                deletable = false;
                month = item[0] ? moment(item[0]) : now;

                console.log(month, termination, month >= terminationDate);
                if (month < now) {
                    disabled = true;
                } else if (terminationDate && (month >= terminationDate)) {
                    disabled = true;
                }
                if (month >= now) {
                    deletable = true;
                }
            }
            return (
                <li key={index} className="fteItem">
                    <MonthPicker
                        format={monthFormat}
                        placeholder="请选择"
                        style={{ width: 100 }}
                        disabled={disabled || isAsh || !canEdit}
                        value={genMomentDate(item[0])}
                        disabledDate={disabledDate}
                        onChange={(date, dateString) => handleFteChange(dateString, index, 0)}
                    />
                    <InputNumber
                        step={0.1}
                        precision={2}
                        placeholder="FTE数量"
                        style={{ width: 100, marginLeft: 20 }}
                        disabled={disabled || isAsh || !canEdit}
                        value={item[1]}
                        onChange={value => handleFteChange(value, index, 1)}
                    />
                    {
                        (deletable && canEdit) &&
                        <Icon
                            type="minus-circle-o"
                            onClick={() => remove(index)}
                        />
                    }
                </li>
            );
        });
        return result;
    };

    return (
        <li className="modal-item">
            <div className="item-left"><Text asterisk={asterisk} colon={true}>FTE需求</Text></div>
            <div className="item-right">
                <div>
                    <MonthPicker
                        format={monthFormat}
                        placeholder='起始时间'
                        style={{ width: 90 }}
                        value={genMomentDate(data.startMonth)}
                        disabledDate={(value) => disabledDate(value, 'startTime')}
                        onChange={(date, dateString) => onChange(dateString, 'startMonth')}
                    />
                    <span style={{ margin: '0 6px' }}>-</span>
                    <MonthPicker
                        format={monthFormat}
                        placeholder='截止时间'
                        style={{ width: 90 }}
                        value={genMomentDate(data.endMonth)}
                        disabledDate={(value) => disabledDate(value, 'endTime')}
                        onChange={(date, dateString) => onChange(dateString, 'endMonth')}
                    />
                    <InputNumber
                        step={0.1}
                        precision={2}
                        placeholder="月均FTE数"
                        style={{ width: 90, marginLeft: 10 }}
                        value={data.fte}
                        onChange={value => onChange(value, 'fte')}
                    />
                    <Button style={{marginLeft: 10}} disabled={isAsh || !canEdit || (terminationDate && now >= terminationDate)} onClick={addFte}>添加\更新</Button>
                </div>
                <ul className="fteList">
                    {getFteContent()}
                </ul>
            </div>
        </li>
    );
}


// WEBPACK FOOTER //
// ./src/components/user/require/components/FteRequirement.js